import React, { useEffect, useState } from "react";
import { Wrapper } from "./Theme";
import { EditTemplate } from "../EditTemplate/EditTemplate";
import MyTemplateCreateCampain from "./MyTemplateCreateCampain/MyTemplateCreateCampain";
import { SendEmail } from "../SendEmail/SendEmail";
import { setCardContent } from "services/api/communication";
import { useDispatch } from "react-redux";

export const MyTemplate = ({
  formik,
  cardContent,
  onNext,
  activeStep,
  onBack,
  setActiveStep,
  setCardName,
  handleResetFormik
}) => {
  const [viewTemplate, setViewTemplate] = useState(false);
  const dispatch=useDispatch()
  const renderContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <MyTemplateCreateCampain
            formik={formik}
            cardContent={cardContent}
            onNext={onNext}
            activeStep={activeStep}
            setViewTemplate={setViewTemplate}
            viewTemplate={viewTemplate}
            setActiveStep={setActiveStep}
            onBack={()=>dispatch(setCardContent("Create Campaign"))}
           
          />
        );
      case 1:
        return (
          <EditTemplate
            formik={formik}
            onNext={onNext}
            onBack={onBack}
            setViewTemplate={setViewTemplate}
            viewTemplate={viewTemplate}
          />
        );
      case 2:
        return (
          <SendEmail
            formik={formik}
            onNext={onNext}
            onBack={onBack}
            isMultiple={false}
            setActiveStep={setActiveStep}
            setViewTemplate={setViewTemplate}
            step={1}
            setCardName={setCardName}
          />
        );

      default:
        return;
    }
  };

  return <Wrapper>{renderContent()}</Wrapper>;
};
